// Plays the alarm tone without ever throwing.
//
// Audio only plays without a click where autoplay is allowed: the Station
// Board desktop app (electron-main.js turns the restriction off), or a kiosk
// browser configured to allow it (see README "Alarm sound"). In an ordinary
// browser tab, play() is rejected until someone interacts with the page; that
// rejection is expected, so it is swallowed here, and reported once so it's
// visible when diagnosing a silent board.
let warned = false;

export function playAlarmTone(src) {
  try {
    const audio = new Audio(src);
    const played = audio.play();
    if (played && typeof played.catch === "function") {
      played.catch((err) => {
        if (!warned && err && err.name === "NotAllowedError") {
          warned = true;
          console.warn(
            "Alarm tone blocked by the browser's autoplay policy. Use the Station Board desktop app, " +
              "or allow autoplay for this site on the kiosk (see README: Alarm sound)."
          );
        }
      });
    }
    return audio;
  } catch (err) {
    return null;
  }
}
